import {Component, OnInit, Injectable, ViewChild, ElementRef, EventEmitter, Output, Input} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {APIURL} from "../../services/url.config";

import { Subject } from 'rxjs';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'capd-client-submission',
    templateUrl: './capd-client-submission.components.html'
})
@Injectable()
export class ClientMockSubmitComponent implements OnInit {

    @Input() public authForm: any;
    @Input() public sessionId: any;
    @Input() public urlExtensions: any;

    message = 'Submitted';
    @Output() messageEvent = new EventEmitter<string>();

    // set all necessary fields
    url = '';
    returnUrl: string;
    narrative: UntypedFormControl;
    selectedValue: UntypedFormControl;
    @ViewChild('stickyMenu', { static: false }) menuElement: ElementRef;
    scroll = new Subject<number>();
    timeout: any = null;

    // use this to get the data for the narrative
    payloadForm = new UntypedFormGroup({
        narrative: new UntypedFormControl(),
        selectedValue: new UntypedFormControl()
    });

    // initialize all template data to be provided to the user
    public data = [
        {
            id: 0,
            name: 'Standard Submission',
            value: `BMI > 51. Patient is morbidly obese. Heart failure with EF 35% . CKD.`,
        }, {
            id: 2,
            name: 'EBR Submission',
            value: `_AppSchema : GenericSections , TargetApplication :{ Name : Cerner , Version :  }, Patient :{ FirstName : Upgarcia , LastName : Bartholomew ,
            DOB : 20090109 , MRN : 123456 , Encounter : 0\/12345677 }, Document :{ DocumentID : Patient Documents , Sections :[{ SectionName : DynamicDoc - Admission H&P Note ,
            SectionInfo : the patient has heart failure. ckd. }]}, User :{ Name : Canseco, Jose , OID :  }, ChangeEventType :[ Patient_Changed , Document_Changed ],
            AppSchema : GenericSections`,
        }
    ];

    // set up all necessary connection tools
    sending: any;
    constructor (
        private http: HttpClient,
        private formBuilder: UntypedFormBuilder,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        // initialize screen at the top of the page on load
        window.scrollTo(0, 0);
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    ngOnDestroy() {
        this.scroll.complete();
    }

    onKeySearch(event: any, formValues) {
        clearTimeout(this.timeout);
        const temp = this;
        this.timeout = setTimeout(function () {
            if (event.keyCode !== 13) {
                temp.submitContext(formValues);
            }
        }, 1000);
    }

    submitContext(formValues) {
        // save the narrative in local storage to be repopulated on form reload
        localStorage.setItem('narrative', formValues.narrative);

        // set the global narrative so that it can be shared across the application components
        const narr = (<HTMLInputElement>document.getElementById('emrInput'));
        const narrative = narr.value.toString();

        // make api call
        const headers = new HttpHeaders()
            .set('Authorization',  'Basic ' + btoa(this.authForm.fdUsername + ':' + this.authForm.fdPassword))
            .set('cache-control', 'no-cache, private')
            .set('Content-Type', 'application/json');

        const body = {
            narrative: narrative,
            nlpParameters: {
                'nlp.reasoningType' : 'CDI.'
            }
        };

        this.url = APIURL + 'capd-client/rest/incnlp/sessions/' + this.sessionId + '/1?' + this.urlExtensions;

        return this.http
        .put(this.url, body, { headers: headers })
        .subscribe(
            val => {
                console.log('PUT call successful value returned in body', val);
            }, response => {
                console.log('PUT call in error', response);
            }, () => {
                console.log('PUT completed.');
                this.sendRefreshMessage('Submitted');
            }
        );
    }

    selectTemplate(template) {
        const narrativeEntry = <HTMLInputElement>document.getElementById('emrInput');
        narrativeEntry.value = template;
        this.submitContext(template);
    }

    sendRefreshMessage(message) {
        this.messageEvent.emit(message);
    }

    clearCards() {
        this.messageEvent.emit('Clear');
        this.payloadForm.reset();
    }
}
